import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [55.643343, -5.223189, 27.8],
  [55.643333, -5.222985, 27.8],
  [55.643279, -5.222807, 27.8],
  [55.643204, -5.222652, 27.8],
  [55.643123, -5.222503, 27.8],
  [55.643038, -5.22238, 27.8],
];

export default stream;
